import { ReactComponent as Icon } from '../../assets/icons/noDataFound.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
